export default __webpack_public_path__ + "a744e9e021d3136830fc1ec41ee7aee88b1e6134c91df8b0f1d9d2647c48c2cd.svg";